import { API } from "@/lib/api";
import { ReadProject, WriteProject } from "@/types/project";
import { APIService } from "../../../services/api";
import { WriteProjectEndDate } from "@/types/projectEndDate";

const projectService = new APIService<ReadProject, WriteProject>(API.Projects);

export const ProjectService = {
  ...projectService,
  updateEndDate: (projectId: string, data: WriteProjectEndDate) =>
    projectService.patch(projectId, data, "end-date"),
  requestApproval: (projectId: string) =>
    projectService.patch(projectId, {}, "request-approval"),
  approve: (projectId: string) =>
    projectService.patch(projectId, {}, "approve"),
  reject: (projectId: string, comments: string[]) =>
    projectService.patch(projectId, { comments }, "reject"),
  close: (projectId: string) => projectService.patch(projectId, {}, "close"),
  reopen: (projectId: string) => projectService.patch(projectId, {}, "reopen"),
  restore: (projectId: string) =>
    projectService.patch(projectId, {}, "restore"),
};
